import { FC } from 'react';

import { CloseIcon, IcBackIcon, IcCopyStrokeIcon } from '@gem/icons';
import { IconButton } from '@gem/ui-kit';

import { Features } from 'APP/packages/features/Features';

import styles from './PopupHeader.style.m.scss';

interface PopupHeaderProps {
  onBackClick: (() => void) | null;
  onCopyClick?: () => void;
  onClose: () => void;
}

export const PopupHeader: FC<PopupHeaderProps> = ({ onBackClick, onCopyClick, onClose }) => {
  return (
    <div className={styles.container}>
      <div className={styles.arrowBlock}>
        {onBackClick && (
          <IconButton
            Icon={IcBackIcon}
            onClick={onBackClick}
          />
        )}
      </div>
      <div className={styles.control}>
        {Features.isStickerDeepLinkEnabled() && (
          <IconButton
            Icon={IcCopyStrokeIcon}
            className={styles.copy}
            onClick={onCopyClick}
          />
        )}

        <IconButton
          Icon={CloseIcon}
          onClick={onClose}
          dataTest="close-popup"
        />
      </div>
    </div>
  );
};
